<template>
</template>

<script>

	export default {
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.$cookie.set("referral", this.$route.params.hash_id, 14);
			this.$router.push("/register");
		},
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Referral.vue